<template>
	<div full-height>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack(-1)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Change Number</v-toolbar-title>
		</v-toolbar>

		<div class="hasToolbar">

			<v-card noshadow>
				<v-card-text nopadding>
					<v-form>

						<v-layout pt-3 align-center row wrap style="max-width:400px">

				            <v-flex xs12 sm12 md12 form-item>
				               <v-text-field  
				               		v-model="newPhoneNumber" 
				               		label="Enter New Mobile Number" 
				               		type="tel"
				               		prefix="+91"
				               		hide-details
				               		placeholder=" "
				               		v-validate="'required|numeric|min:10|max:10'"
				               		:maxlength="10"
				               		data-vv-name="newnumber" 
				               		data-vv-as="mobile number"
				               		hide-details 
				               		required>
				               			
				               	</v-text-field>
				            </v-flex>


				            <v-flex xs12 sm12 md12 right-align mt-2 form-item>
				               <v-btn class="mr-0" color="primary" dark @click="fn_checkValidation">Next</v-btn>
				            </v-flex>

						</v-layout>

						<!-- <v-container justify-center align-center row fill-height pt-3>
							
						</v-container> -->

					</v-form>
				</v-card-text>
			</v-card>
		</div>
		
	</div>
</template>

<script>

	export default{
		data(){
			return{
				newPhoneNumber:null,
				loading:false
			}
		},
		methods:{
			
			fn_checkValidation: function(){
				let self = this;
				this.$validator.validateAll().then((result) => {
			        if (result) {
			        	// this.$root.fn_getAuthToken(function(token){
			         //        self.$root.fn_getPhoneNumber(token, function(mobileNumber){
			         //            self.hideLoading();
			         //            self.fn_getOtp(mobileNumber);
			         //        })
			         //    })
			        	this.fn_getOtp();
			        }
			        else{
			        	this.showToast("Invalid Mobile Number");
			        }
			    });
			},

			fn_getOtp: function(){
				if(!navigator.onLine){
					this.showToast('Internet not available');
					return;
				}
						
				this.$router.push({
	                name:'otpVerification', 
	                query:{mobile_number:this.newPhoneNumber, requestType:4},
	                params: {
	                    // verifyCallback: this.fn_changeNumber
	                    verifyCallback: this.fn_updatePhoneNumber
	                }
	            });
			},

			// fn_getTokenToChangeNumber: function(){
			// 	if(!navigator.onLine){
			// 		this.showToast('Internet not available');
			// 		return;
			// 	}

			// 	let self = this;
			// 	this.showLoading('Please wait...');
			// 	this.$root.fn_getAuthToken(function(token){
	  //               self.fn_changeNumber(token);
	  //           });
			// },

			// fn_changeNumber: function(oldToken, newNumber){
			// 	if(!navigator.onLine){
			// 		this.showToast('Internet not available');
			// 		this.hideLoading();
			// 		return;
			// 	}
				
			// 	var self = this;

			// 	let postObj = {};
			// 	postObj.BusinessID = this.$root.CurrentBusiness.BusinessID;
			// 	postObj.MobileNumber = '91'+ this.newPhoneNumber;
			// 	// postObj.token = token;
			// 	postObj.token = oldToken;

			// 	console.log(JSON.stringify(postObj));

			// 	this.postServerData('ChangeNumber', postObj, 
			// 		{
			// 			onSuccess: function(response){
			// 	          	console.log(response);
			// 	          	self.fn_updatePhoneNumber(newNumber);
			// 	        }, 
			// 	        onError: function(error){
			// 	          	console.log(error);
			// 	          	self.hideLoading();
			// 	          	if(typeof JSON.parse(error) == 'object'){
			// 	          		let response = JSON.parse(error);
			// 	          		self.showToast(response.Message);
			// 	          	}
			// 	        },
			// 		}
			// 	);
			// },

			fn_updatePhoneNumber: function(newNumber){
				let self = this;
				let postObj = {};
				postObj.phoneNumber = '91'+this.newPhoneNumber;
				postObj.businessId = this.$root.CurrentBusiness.BusinessID;

	            this.postData('UpdatePhoneNumber', postObj, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.hideLoading();
	                        // self.$root.CurrentBusiness.AdminMobileNumber = '91'+self.newPhoneNumber;
	                        self.$root.CurrentBusiness.BusinessProfileNumber = '91'+newNumber;
	                        self.showToast("Mobile Number changed");
	                        self.fn_goBack(-2);
	                    },
	                    onError: function(error){
	                        console.log(error);
	                        self.hideLoading();
	                        self.showToast('Something went wrong. Try again');
	                    }
	                }
	            );
			},

			fn_goBack: function(value){
				this.$router.go(value ? value : -1);
			}

		},
		mounted: function(){
			window.js_globals.fn_onBackPress = this.fn_goBack;
			console.log(this.$route);
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/registration/change_phone_number.vue